import { useEffect, useState } from "react";
import { Plus, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, errText, img } from "../../lib/api";
import { Btn, F, PageHeader, Uploader } from "../../components/admin/ui";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { ConfirmDelete } from "./Products";

const EMPTY = { name_ar: "", name_en: "", slug: "", image: "", sort: 0 };

export default function Categories() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/categories").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const body = { ...edit, sort: Number(edit.sort || 0) };
      if (edit.id) await api.put(`/admin/categories/${edit.id}`, body);
      else await api.post("/admin/categories", body);
      toast.success("تم الحفظ");
      setEdit(null);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail === "slug_exists" ? "الرابط مستخدم مسبقًا" : errText(e));
    }
  };

  return (
    <div data-testid="admin-categories">
      <PageHeader title="التصنيفات" desc="تظهر في قائمة التنقل وعلى الصفحة الرئيسية. (الجديدة والعروض تعتمد على وسوم المنتج)">
        <Btn data-testid="add-category-button" onClick={() => setEdit(EMPTY)}><Plus size={16} />إضافة تصنيف</Btn>
      </PageHeader>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((c) => (
          <div key={c.id} data-testid={`category-card-${c.slug}`} className="flex gap-4 rounded-md border border-gray-200 bg-white p-4">
            <img src={img(c.image)} alt="" className="h-20 w-16 rounded object-cover" />
            <div className="flex-1">
              <p className="font-bold">{c.name_ar}</p>
              <p className="text-xs text-gray-500" dir="ltr">/shop/{c.slug}</p>
              <p className="mt-1 text-xs text-gray-500">{c.product_count} منتج</p>
            </div>
            <div className="flex flex-col gap-1">
              <button onClick={() => setEdit(c)} className="rounded p-1.5 hover:bg-gray-100" data-testid={`edit-category-${c.slug}`}><Pencil size={15} /></button>
              <ConfirmDelete testid={`delete-category-${c.slug}`} onConfirm={async () => { await api.delete(`/admin/categories/${c.id}`); load(); }} />
            </div>
          </div>
        ))}
      </div>
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent dir="rtl" className="max-w-md">
          <DialogTitle>{edit?.id ? "تعديل التصنيف" : "تصنيف جديد"}</DialogTitle>
          {edit && (
            <div className="space-y-3">
              <F label="الاسم بالعربية" testid="category-name-ar-input" value={edit.name_ar} onChange={(v) => setEdit({ ...edit, name_ar: v })} />
              <F label="English name" dir="ltr" value={edit.name_en} onChange={(v) => setEdit({ ...edit, name_en: v })} />
              <F label="الرابط (slug)" dir="ltr" testid="category-slug-input" value={edit.slug} onChange={(v) => setEdit({ ...edit, slug: v })} />
              <F label="الترتيب" type="number" value={edit.sort} onChange={(v) => setEdit({ ...edit, sort: v })} />
              <div className="flex items-center gap-3">
                {edit.image && <img src={img(edit.image)} alt="" className="h-16 w-12 rounded object-cover" />}
                <Uploader multiple={false} label="صورة التصنيف" onUploaded={(u) => setEdit({ ...edit, image: u[0] })} />
              </div>
              <Btn data-testid="save-category-button" className="w-full" onClick={save} disabled={!edit.name_ar}>حفظ</Btn>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
